// Components
import Image from 'next/image'
import Link from 'next/link'

import { TServiceItem } from '@/shared/types/deprecated-types'

import cl from './ServiceItem.module.scss'

export type ServiceItemProps = {
	service: TServiceItem
}

/**
 * ServiceItem component
 */
export const ServiceItem = ({ service }: ServiceItemProps): JSX.Element => {
	return (
		<section className={cl.section}>
			<Link prefetch={false} href={service.LINK_VALUE} className={cl.link}>
				<div className={cl.item}>
					<Image
						src={service.PREVIEW_PICTURE}
						width={678}
						height={295}
						alt={service.NAME}
						className={cl.img}
						priority
						quality={100}
					/>
					<div>
						<h4 className={cl.title}>{service.NAME}</h4>
						{service.DESCRIPTION && <p>{service.DESCRIPTION}</p>}
					</div>
				</div>
			</Link>
		</section>
	)
}
